"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhotomeasureMapOverlay = void 0;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
const core_shared_1 = require("@ikegps/core-shared");
const mobx_1 = require("mobx");
const mithril_component_1 = require("../../components/mithril.component");
const theme_1 = require("../../components/theme");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const CSS = {
    container: 'c-PhotomeasureOverlay',
    orca: 'c-PhotomeasureOverlay__device',
    orcaIcon: 'c-PhotomeasureOverlay__orcaIcon',
    fov: 'c-PhotomeasureOverlay__fov',
    fovSprite: 'c-PhotomeasureOverlay__fovSprite',
    label: 'c-PhotomeasureOverlay__label',
};
const Style = {
    [CSS.container]: {
        position: 'absolute',
    },
    [CSS.orca]: {
        position: 'absolute',
        transform: 'translate3d(-16px, -16px, -1px)',
        width: '32px',
        height: '32px',
        borderRadius: '16px',
        boxShadow: theme_1.DefaultTheme.shadow.box.dp4,
    },
    [CSS.orcaIcon]: {
        width: '32px',
        height: '32px',
        transformOrigin: '50% 50%',
    },
    [CSS.fov]: {
        position: 'absolute',
        left: 0,
        top: 0,
        transform: 'translate3d(-75px, -129px, -1px)',
    },
    [CSS.fovSprite]: {
        width: '150px',
        height: '129px',
        transformOrigin: '50% 100%',
    },
    [CSS.label]: {
        paddingTop: '20px',
    },
};
(0, theme_1.addStyles)(Style);
class PhotomeasureMapOverlay extends mithril_component_1.IMithrilComponent {
    constructor(options) {
        super();
        this.name = 'PhotomeasureMapOverlay';
        this.overlay = new google.maps.OverlayView();
        this.capture = options.capture || null;
        this.overlay.onAdd = () => {
            this.el = this.overlay.getPanes().overlayLayer;
            services_1.Services.Render.mount(this.el, this, this.name);
        };
        this.overlay.onRemove = () => {
            if (this.el) {
                services_1.Services.Render.mount(this.el, null, this.name);
            }
        };
        this.overlay.draw = this.onDraw.bind(this);
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        services_1.Services.Map.isReadyPromise.then(() => {
            this.overlay.setMap(services_1.Services.Map.map);
        });
    }
    setCapture(capture) {
        this.capture = capture;
        this.onDraw();
    }
    onRemove() {
        if (this.el) {
            services_1.Services.Render.mount(this.el, null, this.name);
        }
    }
    onDraw() {
        if (this.el) {
            services_1.Services.Render.render(this.el, this.view());
        }
    }
    canSeeFieldOfView() {
        return services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_MAP_FIELD_OF_VIEW);
    }
    get nodes() {
        const projection = this.overlay.getProjection();
        if (projection && this.capture && this.capture.device && this.canSeeFieldOfView()) {
            const { latitude, longitude } = this.capture.device;
            const point = projection.fromLatLngToDivPixel(new google.maps.LatLng({
                lat: latitude,
                lng: longitude,
            }));
            return (0, mithril_1.m)('div', {
                className: CSS.container,
                style: {
                    left: `${point.x}px`,
                    top: `${point.y}px`,
                },
            }, [
                (0, mithril_1.m)('div', {
                    className: CSS.fov,
                }, (0, mithril_1.m)('img', {
                    src: (0, theme_1.assetPath)('/images/fov-cone.svg'),
                    className: CSS.fovSprite,
                    style: {
                        transform: `rotate(${this.capture.orientation.bearing}rad)`,
                    },
                })),
                (0, mithril_1.m)('div', {
                    className: CSS.orca,
                }, (0, mithril_1.m)('img', {
                    src: (0, theme_1.assetPath)('/images/ike-device.svg'),
                    className: CSS.orcaIcon,
                    style: {
                        transform: `rotate(${this.capture.orientation.bearing}rad)`,
                    },
                })),
                (0, mithril_1.m)('div', {
                    className: CSS.label,
                }, core_shared_1.IkeUnit.display(this.capture.distance, services_1.Services.UserSettings.units)),
            ]);
        }
        return null;
    }
}
exports.PhotomeasureMapOverlay = PhotomeasureMapOverlay;
tslib_1.__decorate([
    mobx_1.observable
], PhotomeasureMapOverlay.prototype, "capture", void 0);
tslib_1.__decorate([
    mobx_1.action
], PhotomeasureMapOverlay.prototype, "setCapture", null);
//# sourceMappingURL=photomeasure.map.overlay.js.map